import { FunctionComponent } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { contextSignInUserAtom } from "../state/atoms/user";

const ProtectedRoutesAdmin: FunctionComponent<{}> = () => {
  const signedInUser = useRecoilValue(contextSignInUserAtom);
  return signedInUser?.isAdmin ? (
    <Outlet />
  ) : (
    <Navigate to="/my-personal-area" />
  );
};
export default ProtectedRoutesAdmin;
